module.exports = __webpack_public_path__ + "img/chain18.708d36b5.png";